import { render, staticRenderFns } from "./MarketList.vue?vue&type=template&id=33d3fd58&scoped=true&"
import script from "./MarketList.vue?vue&type=script&lang=ts&"
export * from "./MarketList.vue?vue&type=script&lang=ts&"
import style0 from "./MarketList.vue?vue&type=style&index=0&id=33d3fd58&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d3fd58",
  null
  
)

export default component.exports